import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRing = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 80,
			height: 80,
			rx: 40,
			fill: "#CB7D61",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 8,
			width: 64,
			height: 64,
			rx: 32,
			fill: "#CB7D61",
			fillOpacity: .18
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 16,
			width: 48,
			height: 48,
			rx: 24,
			fill: "#CB7D61"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40,
			cy: 40,
			r: 9,
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgRing);
export default ForwardRef;
